import React, { createElement } from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { compose } from 'redux';

import Option from './Option';

const optionSource = {
  beginDrag(props) {
    return {
      value: props.value,
      index: props.index,
    };
  },
  endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      // You can check whether the drop was successful
      // or if the drag ended but nobody handled the drop
      if (props.onDragEnd) {
        props.onDragEnd()
      }
      return;
    }

    // When dropped on a compatible target, do something.
    // Read the original dragged item from getItem():
    const item = monitor.getItem();

    // You may also read the drop result from the drop target
    // that handled the drop, if it returned an object from
    // its drop() method.
    const dropResult = monitor.getDropResult();

    if (dropResult.onBox && props.onDrop) {
      props.onDrop(item.value, item.targetIndex, item.direction);
    } else if (props.onMove) {
      props.onMove(item.index, item.targetIndex);
    }

    // 避免同時觸發setState
    if (props.onDragEnd) {
      setTimeout(props.onDragEnd)
    }
  }
};

const optionTarget = {
  hover(props, monitor, component) {
    if (!component) {
			return null
		}
		const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

		// Don't replace items with themselves
		if (dragIndex === hoverIndex) {
			return
		}

		// Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

		// Determine mouse position
		const clientOffset = monitor.getClientOffset()

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%
    const direction = hoverClientY < hoverMiddleY ? 0 : 1;
		// Dragging downwards
		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return
		}

		// Dragging upwards
		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return
		}

    // Time to actually perform the action
    if (props.onHover) {
      props.onHover(hoverIndex, direction)
    }

		// Note: we're mutating the monitor item here!
		// Generally it's better to avoid mutations,
		// but it's good here for the sake of performance
    // to avoid expensive index searches.
    const item = monitor.getItem()
    item.targetIndex = hoverIndex
    item.direction = direction
  },
  drop(props, monitor) {
    if (monitor.didDrop()) {
      // If you want, you can check whether some nested
      // target already handled drop
      return;
    }
    const item = monitor.getItem();
    const res = {
      targetIndex: item.targetIndex,
      direction: item.direction,
    };
    if (item.index === undefined) {
      return {
        ...res,
        onBox: true,
      };
    } else {
      return res
    }
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}

function collectDrop(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

function DraggableOption({
  connectDragSource,
  connectDropTarget,
  isDragging,
  onMove,
  onHover,
  ...props
}) {
  const deco = props.inBox ? compose(connectDragSource, connectDropTarget) : connectDragSource;
  return deco(
    <div>
      <Option {...props} />
    </div>
  );
}

export default (props) => {
  const withDrag = DragSource('option', optionSource, collect);
  const withDrop = DropTarget('option', optionTarget, collectDrop);
  const deco = props.inBox ? compose(withDrop, withDrag) : withDrag;
  return createElement(deco(DraggableOption), props);
};
